import { Group, Identifiable, ProjectResource, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveResourceInProjectResourceGroup(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<ProjectResource>,
    group: Identifiable<Group>,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projectResourceGroups/${group.uuid}/resources`,
      method: HttpMethods.POST,
      headers: { "Content-Type": "text/uri-list" },
      data: `projectMembers/${uuid}`,
    });
}

function saveResourceInPlanzoneResourceGroup(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Resource>, group: Identifiable<Group>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzoneResourceGroups/${group.uuid}/resources`,
      method: HttpMethods.POST,
      headers: { "Content-Type": "text/uri-list" },
      data: `resources/${uuid}`,
    });
}

function saveResourceInResourceGroup(httpClient: HttpClient) {
  return (resource: any, group: Identifiable<Group>) =>
    group.resourceType === "project"
      ? saveResourceInProjectResourceGroup(httpClient)(resource, group)
      : saveResourceInPlanzoneResourceGroup(httpClient)(resource, group);
}

export { saveResourceInResourceGroup };
